import(/* webpackMode: "eager" */ "/workspace/src/app/hondenkapsalons/page.tsx");
